import * as types from '@/constants/mutationTypes'

const state = {
  gmailApi: {},
  serviceAccountTokens: {},
  sendAsEmails: [],
  configApiKeys: {}
}
const getters = {
  gmailApi: state => state.gmailApi,
  sendAsEmails: state => state.sendAsEmails,
  serviceAccountTokens: state => state.serviceAccountTokens,
  configApiKeys: state => state.configApiKeys
}
const actions = {
  setGmailApi ({commit}, data) {
    commit(types.SET_GMAIL_API, {data})
  },
  setConfigApiKeys ({commit}, data) {
    commit(types.SET_CONFIG_API_KEYS, {data})
  },
  setSendAsEmails ({commit}, data) {
    commit(types.SET_SEND_AS_EMAILS, {data})
  },
  setServiceAccountTokens ({commit}, data) {
    commit(types.SET_SERVICE_ACCOUNT_TOKENS, {data})
  }
}
const mutations = {
  [types.SET_GMAIL_API] (state, {data}) {
    state.gmailApi = data
  },
  [types.SET_CONFIG_API_KEYS] (state, {data}) {
    state.configApiKeys = data
  },
  [types.SET_SEND_AS_EMAILS] (state, {data}) {
    state.sendAsEmails = data
  },
  [types.SET_SERVICE_ACCOUNT_TOKENS] (state, {data}) {
    state.serviceAccountTokens = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Gapi/modules/store.js